import _React from 'react';

// Custom Heatmap Component
const BedOccupancyHeatmap = ({ data }) => {
	// Get max occupancy for normalization
	const maxOccupancy = Math.max(...data.map(item => item.occupancy));
	const minOccupancy = Math.min(...data.map(item => item.occupancy));

	// Calculate grid dimensions based on data length
	const totalRooms = data.length;
	const cols = Math.ceil(Math.sqrt(totalRooms));
	const rows = Math.ceil(totalRooms / cols);

	// Color function - returns opacity based on occupancy level
	const getHeatmapColor = occupancy => {
		if (occupancy < 200) {
			return null;
		}
		if (maxOccupancy === minOccupancy) return 0.5; // Handle edge case
		const normalizedValue = (occupancy - minOccupancy) / (maxOccupancy - minOccupancy);
		return Math.max(0.1, normalizedValue); // Minimum 10% opacity
	};

	// Get color based on occupancy level (same as original)
	const getColor = occupancy => {
		if (occupancy >= 400) return '#ff4d4f'; // Red for high
		if (occupancy >= 200) return '#faad14'; // Yellow for medium
		if (occupancy < 200) {
			console.log(occupancy);
			return '#52c41a'; // Green for low
		}
	};

	return (
		<div style={{ width: '100%', height: '300px', padding: '20px' }}>
			<div
				style={{
					display: 'grid',
					gridTemplateColumns: `repeat(${cols}, 1fr)`,
					gridTemplateRows: `repeat(${rows}, 1fr)`,
					gap: '4px',
					height: '100%',
					width: '100%',
				}}
			>
				{data.map((room, index) => (
					<div
						key={index}
						style={{
							backgroundColor: getColor(room.occupancy),
							opacity: getHeatmapColor(room.occupancy),
							border: '1px solid #e1e1e1',
							borderRadius: '4px',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
							padding: '4px',
							fontSize: '10px',
							fontWeight: 'bold',
							color: '#fff',
							cursor: 'pointer',
							transition: 'transform 0.2s, box-shadow 0.2s',
							minHeight: '40px',
						}}
						onMouseEnter={e => {
							e.target.style.transform = 'scale(1.05)';
							e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
							e.target.style.zIndex = '10';
						}}
						onMouseLeave={e => {
							e.target.style.transform = 'scale(1)';
							e.target.style.boxShadow = 'none';
							e.target.style.zIndex = '1';
						}}
						title={`${room.name}: ${room.occupancy} occupancy counts`}
					>
						<div
							style={{
								fontSize: '8px',
								textAlign: 'center',
								lineHeight: '1',
								marginBottom: '2px',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
								maxWidth: '100%',
							}}
						>
							{room.name}
						</div>
						<div
							style={{
								fontSize: '12px',
								fontWeight: 'bold',
								textAlign: 'center',
							}}
						>
							{room.occupancy}
						</div>
					</div>
				))}

				{/* Fill empty cells if needed */}
				{Array.from({ length: rows * cols - totalRooms }).map((_, index) => (
					<div key={`empty-${index}`} style={{ opacity: 0 }} />
				))}
			</div>

			{/* Legend */}
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					marginTop: '15px',
					fontSize: '12px',
					gap: '20px',
				}}
			>
				<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
					<div
						style={{
							width: '15px',
							height: '15px',
							backgroundColor: '#52c41a',
							border: '1px solid #e1e1e1',
							borderRadius: '2px',
						}}
					/>
					<span>Low (0-49%)</span>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
					<div
						style={{
							width: '15px',
							height: '15px',
							backgroundColor: '#faad14',
							border: '1px solid #e1e1e1',
							borderRadius: '2px',
						}}
					/>
					<span>Medium (50-79%)</span>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
					<div
						style={{
							width: '15px',
							height: '15px',
							backgroundColor: '#ff4d4f',
							border: '1px solid #e1e1e1',
							borderRadius: '2px',
						}}
					/>
					<span>High (80%+)</span>
				</div>
				<div style={{ marginLeft: '10px', fontStyle: 'italic' }}>Darker shades = Higher usage</div>
			</div>
		</div>
	);
};

export default BedOccupancyHeatmap;
